const DummySalons = [
  {
      "openingHours": [
          {
            "from": "08:00",
            "to": "16:00",
            "day": 1,
            "siteId": 101,
            "isOpen": true
          },
          {
            "from": "08:00",
            "to": "16:00",
            "day": 2,
            "siteId": 101,
            "isOpen": false
          },
          {
            "from": "08:00",
            "to": "16:00",
            "day": 3,
            "siteId": 101,
            "isOpen": false
          },
          {
            "from": "08:00",
            "to": "16:00",
            "day": 4,
            "siteId": 101,
            "isOpen": false
          },
          {
            "from": "08:00",
            "to": "16:00",
            "day": 5,
            "siteId": 101,
            "isOpen": false
          },
          {
            "from": "08:00",
            "to": "16:00",
            "day": 6,
            "siteId": 101,
            "isOpen": false
          },
          {
            "from": "08:00",
            "to": "16:00",
            "day": 7,
            "siteId": 101,
            "isOpen": false
          }
      ],
      "Active": true,
      "Address": "OLAV KYRRESGT. 33",
      "AndroidActive": true,
      "AndroidActiveAndEnabled": true,
      "AndroidEnabled": true,
      "AppointmentButtonOverrideText": null,
      "AppointmentButtonOverrideUrl": null,
      "AvailableCategories": null,
      "AvailableTreatments": null,
      "AverageRating": 0,
      "BankAccountNumber": "",
      "BonusLifeTime": 24,
      "BookingHours": 0,
      "CancelationHours": 16,
      "CancelationText": "Du kan direkte fra denne applikasjonen avbestille din time inntil 12 timer før avtale. Ved avbestilling mindre enn 12 timer før avtale må du ringe direkte til salongen.",
      "CancelationTitle": "",
      "CancellationTextProduct": "Du kan når som helst avbestille produkter",
      "ChainId": 36,
      "ChainLogoImageVersion": 0,
      "CollectAtStoreEnabled": true,
      "CustomerNote": false,
      "DepartmentProgress": 64,
      "Description": "",
      "DistanceFromLocationInMeters": 0,
      "Email": "demo@vitecsoftware.com",
      "EmailConfirmationSenderAddress": "ikkesvar@odinsystemer.no",
      "EmailConfirmationSubject": "Velkommen til ny time!",
      "EmailConfirmationText": "Dette er en bekreftelse på time bestilt hos {0}. Velkommen til oss {1} kl. {2}!",
      "EmailProductReservationSubject": "",
      "EmailProductReservationText": "Dette er en bekreftelse på produkt bestilt hos {0}. Bestillingen kan hentes fra og med {1} kl. {2}!",
      "Enabled": true,
      "EndHourExceptions": "1970-01-01T00:00:00",
      "EndHours": "1970-01-01T00:00:00",
      "ExtraTextTreatments": "Det finnes et utvalg behandlinger som vi ikke tilbyr på Online bestilling. Ring oss for nærmere informasjon.",
      "FaceBookUrl": "https://www.facebook.com/ramsvik",
      "FacebookUrlEnabled": true,
      "HasAvailableCampaigns": true,
      "HideEmployees": false,
      "HomePageUrl": "http://ramsvik.test.odindata.no",
      "ImageLocation": "https://res.cloudinary.com/odin-systemer-test/image/upload/w_370,h_196,c_fill,g_center/v1552293469/Department/department_101_webbanner.jpg",
      "ImgAltDesciption": "",
      "Industry": 0,
      "InstagramUrl": "https://www.instagram.com/ramsvik",
      "InstagramUrlEnabled": true,
      "InvoiceAddress": "",
      "InvoicePostalArea": "",
      "InvoicePostalCode": "",
      "IphoneActive": true,
      "IphoneActiveAndEnabled": true,
      "IphoneEnabled": true,
      "IsOpen": false,
      "IsOpenException": false,
      "JournalCustomFieldAnamnese": "",
      "JournalCustomFieldDiagnosis": "",
      "JournalCustomFieldTreatment": "",
      "MapLatitude": "60.3907433",
      "MapLongitude": "5.3231823",
      "MapReferenceUseContactInfo": 1,
      "MapUrl": "",
      "MetaDescription": "fixitonlineweb Fixitno_Department fedda tester",
      "MetaKeywords": "",
      "MobileThemeName": "",
      "MobileThemeVersion": 0,
      "Name": "Ramsvik Bergen Sentrum",
      "NoOfRatings": 0,
      "OdinTreatmentIds": null,
      "Open": true,
      "OpenNoConnection": false,
      "OrderDayBeforeReminder": false,
      "OrderSameDayReminder": false,
      "OrganizationNumber": "",
      "PageUrlForSharing": 1,
      "Phone": "55310488",
      "PickUpText": null,
      "PostalArea": "BERGEN",
      "PostalCode": "5014",
      "PreviewTreatments": null,
      "ProductReservationGraceDays": 5,
      "ProductReservationPickUpMinutes": 30,
      "ProductReservationPickUpText": "",
      "RatingCommentsFixitnoCount": 0,
      "SendEmailConfirmation": true,
      "SendEmailConfirmationToSite": true,
      "SendSmsConfirmation": true,
      "ShowInFixItNo": false,
      "ShowPrice": true,
      "Site": "BR01",
      "SiteId": 101,
      "SmsConfirmationText": "Dette er en bekreftelse på time bestilt hos {0}. Velkommen til oss {1} kl. {2}!",
      "SmsProductReservationText": "",
      "SmsSenderNumber": "ramsvik",
      "SnapchatUrl": "https://www.snapchat.com/add/ramsvik",
      "SnapchatUrlEnabled": true,
      "SortOnPopularity": false,
      "StartHourExceptions": "1970-01-01T00:00:00",
      "StartHoures": "1970-01-01T00:00:00",
      "Status": true,
      "TimeSuggestionSize": 15,
      "UrlFrendlyLink": "ramsvik-bergen-sentrum",
      "UrlLink": null,
      "UseChainLogo": false
  },
  {
      "openingHours": [
          {
            "from": "08:00",
            "to": "16:00",
            "day": 1,
            "siteId": 1521,
            "isOpen": false
          },
          {
            "from": "08:00",
            "to": "16:00",
            "day": 2,
            "siteId": 1521,
            "isOpen": false
          },
          {
            "from": "08:00",
            "to": "16:00",
            "day": 3,
            "siteId": 1521,
            "isOpen": false
          },
          {
            "from": "08:00",
            "to": "16:00",
            "day": 4,
            "siteId": 1521,
            "isOpen": false
          },
          {
            "from": "08:00",
            "to": "16:00",
            "day": 5,
            "siteId": 1521,
            "isOpen": false
          },
          {
            "from": "08:00",
            "to": "16:00",
            "day": 6,
            "siteId": 1521,
            "isOpen": false
          },
          {
            "from": "08:00",
            "to": "16:00",
            "day": 7,
            "siteId": 1521,
            "isOpen": false
          }
        ],
      "Active": true,
      "Address": "Laguneveien 1",
      "AndroidActive": false,
      "AndroidActiveAndEnabled": false,
      "AndroidEnabled": false,
      "AppointmentButtonOverrideText": null,
      "AppointmentButtonOverrideUrl": null,
      "AvailableCategories": null,
      "AvailableTreatments": null,
      "AverageRating": 0,
      "BankAccountNumber": "",
      "BonusLifeTime": 24,
      "BookingHours": 0,
      "CancelationHours": 16,
      "CancelationText": "Du kan direkte fra denne applikasjonen avbestille din time inntil 12 timer før avtale. Ved avbestilling mindre enn 12 timer før avtale må du ringe direkte til salongen.",
      "CancelationTitle": "",
      "CancellationTextProduct": "Du kan når som helst avbestille produkter",
      "ChainId": 36,
      "ChainLogoImageVersion": 0,
      "CollectAtStoreEnabled": true,
      "CustomerNote": true,
      "DepartmentProgress": 50,
      "Description": "",
      "DistanceFromLocationInMeters": 0,
      "Email": "tore@fixit.no",
      "EmailConfirmationSenderAddress": "roland@fixit.no",
      "EmailConfirmationSubject": "Bekreftelse på timebestilling",
      "EmailConfirmationText": "Dette er en bekreftelse på time bestilt hos {0}. Velkommen til oss {1} kl. {2}!",
      "EmailProductReservationSubject": "",
      "EmailProductReservationText": "Dette er en bekreftelse på produkt bestilt hos {0}. Bestillingen kan hentes fra og med {1} kl. {2}!",
      "Enabled": true,
      "EndHourExceptions": "1970-01-01T00:00:00",
      "EndHours": "1970-01-01T00:00:00",
      "ExtraTextTreatments": "",
      "FaceBookUrl": "",
      "FacebookUrlEnabled": true,
      "HasAvailableCampaigns": true,
      "HideEmployees": false,
      "HomePageUrl": "http://ramsvik.test.odindata.no",
      "ImageLocation": "https://res.cloudinary.com/odin-systemer-test/image/upload/w_370,h_196,c_fill,g_center/v1552293794/Department/department_1521_webbanner.jpg",
      "ImgAltDesciption": "",
      "Industry": 0,
      "InstagramUrl": "",
      "InstagramUrlEnabled": true,
      "InvoiceAddress": "",
      "InvoicePostalArea": "",
      "InvoicePostalCode": "",
      "IphoneActive": false,
      "IphoneActiveAndEnabled": false,
      "IphoneEnabled": false,
      "IsOpen": false,
      "IsOpenException": false,
      "JournalCustomFieldAnamnese": "",
      "JournalCustomFieldDiagnosis": "",
      "JournalCustomFieldTreatment": "",
      "MapLatitude": "60.2928589",
      "MapLongitude": "5.325301",
      "MapReferenceUseContactInfo": 0,
      "MapUrl": "",
      "MetaDescription": "",
      "MetaKeywords": "",
      "MobileThemeName": "",
      "MobileThemeVersion": 0,
      "Name": "Ramsvik Lagunen",
      "NoOfRatings": 0,
      "OdinTreatmentIds": null,
      "Open": true,
      "OpenNoConnection": false,
      "OrderDayBeforeReminder": false,
      "OrderSameDayReminder": true,
      "OrganizationNumber": "",
      "PageUrlForSharing": 1,
      "Phone": "55135644",
      "PickUpText": null,
      "PostalArea": "RÅDAL",
      "PostalCode": "5239",
      "PreviewTreatments": null,
      "ProductReservationGraceDays": 5,
      "ProductReservationPickUpMinutes": 30,
      "ProductReservationPickUpText": "",
      "RatingCommentsFixitnoCount": 0,
      "SendEmailConfirmation": true,
      "SendEmailConfirmationToSite": true,
      "SendSmsConfirmation": true,
      "ShowInFixItNo": false,
      "ShowPrice": true,
      "Site": "BR09",
      "SiteId": 1521,
      "SmsConfirmationText": "Dette er en bekreftelse på time bestilt hos {0}. Velkommen til oss {1} kl. {2}!",
      "SmsProductReservationText": "",
      "SmsSenderNumber": "ramsvik",
      "SnapchatUrl": "",
      "SnapchatUrlEnabled": true,
      "SortOnPopularity": false,
      "StartHourExceptions": "1970-01-01T00:00:00",
      "StartHoures": "1970-01-01T00:00:00",
      "Status": true,
      "TimeSuggestionSize": 15,
      "UrlFrendlyLink": "/ramsvik-lagunen",
      "UrlLink": null,
      "UseChainLogo": false
  },
  {
    "openingHours": [
        {
          "from": "08:00",
          "to": "16:00",
          "day": 1,
          "siteId": 101,
          "isOpen": true
        },
        {
          "from": "08:00",
          "to": "16:00",
          "day": 2,
          "siteId": 101,
          "isOpen": false
        },
        {
          "from": "08:00",
          "to": "16:00",
          "day": 3,
          "siteId": 101,
          "isOpen": false
        },
        {
          "from": "08:00",
          "to": "16:00",
          "day": 4,
          "siteId": 101,
          "isOpen": false
        },
        {
          "from": "08:00",
          "to": "16:00",
          "day": 5,
          "siteId": 101,
          "isOpen": false
        },
        {
          "from": "08:00",
          "to": "16:00",
          "day": 6,
          "siteId": 101,
          "isOpen": false
        },
        {
          "from": "08:00",
          "to": "16:00",
          "day": 7,
          "siteId": 101,
          "isOpen": false
        }
    ],
    "Active": true,
    "Address": "OLAV KYRRESGT. 33",
    "AndroidActive": true,
    "AndroidActiveAndEnabled": true,
    "AndroidEnabled": true,
    "AppointmentButtonOverrideText": null,
    "AppointmentButtonOverrideUrl": null,
    "AvailableCategories": null,
    "AvailableTreatments": null,
    "AverageRating": 0,
    "BankAccountNumber": "",
    "BonusLifeTime": 24,
    "BookingHours": 0,
    "CancelationHours": 16,
    "CancelationText": "Du kan direkte fra denne applikasjonen avbestille din time inntil 12 timer før avtale. Ved avbestilling mindre enn 12 timer før avtale må du ringe direkte til salongen.",
    "CancelationTitle": "",
    "CancellationTextProduct": "Du kan når som helst avbestille produkter",
    "ChainId": 36,
    "ChainLogoImageVersion": 0,
    "CollectAtStoreEnabled": true,
    "CustomerNote": false,
    "DepartmentProgress": 64,
    "Description": "",
    "DistanceFromLocationInMeters": 0,
    "Email": "demo@vitecsoftware.com",
    "EmailConfirmationSenderAddress": "ikkesvar@odinsystemer.no",
    "EmailConfirmationSubject": "Velkommen til ny time!",
    "EmailConfirmationText": "Dette er en bekreftelse på time bestilt hos {0}. Velkommen til oss {1} kl. {2}!",
    "EmailProductReservationSubject": "",
    "EmailProductReservationText": "Dette er en bekreftelse på produkt bestilt hos {0}. Bestillingen kan hentes fra og med {1} kl. {2}!",
    "Enabled": true,
    "EndHourExceptions": "1970-01-01T00:00:00",
    "EndHours": "1970-01-01T00:00:00",
    "ExtraTextTreatments": "Det finnes et utvalg behandlinger som vi ikke tilbyr på Online bestilling. Ring oss for nærmere informasjon.",
    "FaceBookUrl": "https://www.facebook.com/ramsvik",
    "FacebookUrlEnabled": true,
    "HasAvailableCampaigns": true,
    "HideEmployees": false,
    "HomePageUrl": "http://ramsvik.test.odindata.no",
    "ImageLocation": "https://res.cloudinary.com/odin-systemer-test/image/upload/w_370,h_196,c_fill,g_center/v1552293469/Department/department_101_webbanner.jpg",
    "ImgAltDesciption": "",
    "Industry": 0,
    "InstagramUrl": "https://www.instagram.com/ramsvik",
    "InstagramUrlEnabled": true,
    "InvoiceAddress": "",
    "InvoicePostalArea": "",
    "InvoicePostalCode": "",
    "IphoneActive": true,
    "IphoneActiveAndEnabled": true,
    "IphoneEnabled": true,
    "IsOpen": false,
    "IsOpenException": false,
    "JournalCustomFieldAnamnese": "",
    "JournalCustomFieldDiagnosis": "",
    "JournalCustomFieldTreatment": "",
    "MapLatitude": "61.4536",
    "MapLongitude": "5.8497",
    "MapReferenceUseContactInfo": 1,
    "MapUrl": "",
    "MetaDescription": "fixitonlineweb Fixitno_Department fedda tester",
    "MetaKeywords": "",
    "MobileThemeName": "",
    "MobileThemeVersion": 0,
    "Name": "Ramsvik Bergen Sentrum",
    "NoOfRatings": 0,
    "OdinTreatmentIds": null,
    "Open": true,
    "OpenNoConnection": false,
    "OrderDayBeforeReminder": false,
    "OrderSameDayReminder": false,
    "OrganizationNumber": "",
    "PageUrlForSharing": 1,
    "Phone": "55310488",
    "PickUpText": null,
    "PostalArea": "BERGEN",
    "PostalCode": "5014",
    "PreviewTreatments": null,
    "ProductReservationGraceDays": 5,
    "ProductReservationPickUpMinutes": 30,
    "ProductReservationPickUpText": "",
    "RatingCommentsFixitnoCount": 0,
    "SendEmailConfirmation": true,
    "SendEmailConfirmationToSite": true,
    "SendSmsConfirmation": true,
    "ShowInFixItNo": false,
    "ShowPrice": true,
    "Site": "BR01",
    "SiteId": 101,
    "SmsConfirmationText": "Dette er en bekreftelse på time bestilt hos {0}. Velkommen til oss {1} kl. {2}!",
    "SmsProductReservationText": "",
    "SmsSenderNumber": "ramsvik",
    "SnapchatUrl": "https://www.snapchat.com/add/ramsvik",
    "SnapchatUrlEnabled": true,
    "SortOnPopularity": false,
    "StartHourExceptions": "1970-01-01T00:00:00",
    "StartHoures": "1970-01-01T00:00:00",
    "Status": true,
    "TimeSuggestionSize": 15,
    "UrlFrendlyLink": "ramsvik-bergen-sentrum",
    "UrlLink": null,
    "UseChainLogo": false
},
{
  "openingHours": [
      {
        "from": "08:00",
        "to": "16:00",
        "day": 1,
        "siteId": 101,
        "isOpen": true
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 2,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 3,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 4,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 5,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 6,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 7,
        "siteId": 101,
        "isOpen": false
      }
  ],
  "Active": true,
  "Address": "OLAV KYRRESGT. 33",
  "AndroidActive": true,
  "AndroidActiveAndEnabled": true,
  "AndroidEnabled": true,
  "AppointmentButtonOverrideText": null,
  "AppointmentButtonOverrideUrl": null,
  "AvailableCategories": null,
  "AvailableTreatments": null,
  "AverageRating": 0,
  "BankAccountNumber": "",
  "BonusLifeTime": 24,
  "BookingHours": 0,
  "CancelationHours": 16,
  "CancelationText": "Du kan direkte fra denne applikasjonen avbestille din time inntil 12 timer før avtale. Ved avbestilling mindre enn 12 timer før avtale må du ringe direkte til salongen.",
  "CancelationTitle": "",
  "CancellationTextProduct": "Du kan når som helst avbestille produkter",
  "ChainId": 36,
  "ChainLogoImageVersion": 0,
  "CollectAtStoreEnabled": true,
  "CustomerNote": false,
  "DepartmentProgress": 64,
  "Description": "",
  "DistanceFromLocationInMeters": 0,
  "Email": "demo@vitecsoftware.com",
  "EmailConfirmationSenderAddress": "ikkesvar@odinsystemer.no",
  "EmailConfirmationSubject": "Velkommen til ny time!",
  "EmailConfirmationText": "Dette er en bekreftelse på time bestilt hos {0}. Velkommen til oss {1} kl. {2}!",
  "EmailProductReservationSubject": "",
  "EmailProductReservationText": "Dette er en bekreftelse på produkt bestilt hos {0}. Bestillingen kan hentes fra og med {1} kl. {2}!",
  "Enabled": true,
  "EndHourExceptions": "1970-01-01T00:00:00",
  "EndHours": "1970-01-01T00:00:00",
  "ExtraTextTreatments": "Det finnes et utvalg behandlinger som vi ikke tilbyr på Online bestilling. Ring oss for nærmere informasjon.",
  "FaceBookUrl": "https://www.facebook.com/ramsvik",
  "FacebookUrlEnabled": true,
  "HasAvailableCampaigns": true,
  "HideEmployees": false,
  "HomePageUrl": "http://ramsvik.test.odindata.no",
  "ImageLocation": "https://res.cloudinary.com/odin-systemer-test/image/upload/w_370,h_196,c_fill,g_center/v1552293469/Department/department_101_webbanner.jpg",
  "ImgAltDesciption": "",
  "Industry": 0,
  "InstagramUrl": "https://www.instagram.com/ramsvik",
  "InstagramUrlEnabled": true,
  "InvoiceAddress": "",
  "InvoicePostalArea": "",
  "InvoicePostalCode": "",
  "IphoneActive": true,
  "IphoneActiveAndEnabled": true,
  "IphoneEnabled": true,
  "IsOpen": false,
  "IsOpenException": false,
  "JournalCustomFieldAnamnese": "",
  "JournalCustomFieldDiagnosis": "",
  "JournalCustomFieldTreatment": "",
  "MapLatitude": "62.181003",
  "MapLongitude": "11.440833",
  "MapReferenceUseContactInfo": 1,
  "MapUrl": "",
  "MetaDescription": "fixitonlineweb Fixitno_Department fedda tester",
  "MetaKeywords": "",
  "MobileThemeName": "",
  "MobileThemeVersion": 0,
  "Name": "Ramsvik Bergen Sentrum",
  "NoOfRatings": 0,
  "OdinTreatmentIds": null,
  "Open": true,
  "OpenNoConnection": false,
  "OrderDayBeforeReminder": false,
  "OrderSameDayReminder": false,
  "OrganizationNumber": "",
  "PageUrlForSharing": 1,
  "Phone": "55310488",
  "PickUpText": null,
  "PostalArea": "BERGEN",
  "PostalCode": "5014",
  "PreviewTreatments": null,
  "ProductReservationGraceDays": 5,
  "ProductReservationPickUpMinutes": 30,
  "ProductReservationPickUpText": "",
  "RatingCommentsFixitnoCount": 0,
  "SendEmailConfirmation": true,
  "SendEmailConfirmationToSite": true,
  "SendSmsConfirmation": true,
  "ShowInFixItNo": false,
  "ShowPrice": true,
  "Site": "BR01",
  "SiteId": 101,
  "SmsConfirmationText": "Dette er en bekreftelse på time bestilt hos {0}. Velkommen til oss {1} kl. {2}!",
  "SmsProductReservationText": "",
  "SmsSenderNumber": "ramsvik",
  "SnapchatUrl": "https://www.snapchat.com/add/ramsvik",
  "SnapchatUrlEnabled": true,
  "SortOnPopularity": false,
  "StartHourExceptions": "1970-01-01T00:00:00",
  "StartHoures": "1970-01-01T00:00:00",
  "Status": true,
  "TimeSuggestionSize": 15,
  "UrlFrendlyLink": "ramsvik-bergen-sentrum",
  "UrlLink": null,
  "UseChainLogo": false
},
{
  "openingHours": [
      {
        "from": "08:00",
        "to": "16:00",
        "day": 1,
        "siteId": 101,
        "isOpen": true
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 2,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 3,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 4,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 5,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 6,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 7,
        "siteId": 101,
        "isOpen": false
      }
  ],
  "Active": true,
  "Address": "OLAV KYRRESGT. 33",
  "AndroidActive": true,
  "AndroidActiveAndEnabled": true,
  "AndroidEnabled": true,
  "AppointmentButtonOverrideText": null,
  "AppointmentButtonOverrideUrl": null,
  "AvailableCategories": null,
  "AvailableTreatments": null,
  "AverageRating": 0,
  "BankAccountNumber": "",
  "BonusLifeTime": 24,
  "BookingHours": 0,
  "CancelationHours": 16,
  "CancelationText": "Du kan direkte fra denne applikasjonen avbestille din time inntil 12 timer før avtale. Ved avbestilling mindre enn 12 timer før avtale må du ringe direkte til salongen.",
  "CancelationTitle": "",
  "CancellationTextProduct": "Du kan når som helst avbestille produkter",
  "ChainId": 36,
  "ChainLogoImageVersion": 0,
  "CollectAtStoreEnabled": true,
  "CustomerNote": false,
  "DepartmentProgress": 64,
  "Description": "",
  "DistanceFromLocationInMeters": 0,
  "Email": "demo@vitecsoftware.com",
  "EmailConfirmationSenderAddress": "ikkesvar@odinsystemer.no",
  "EmailConfirmationSubject": "Velkommen til ny time!",
  "EmailConfirmationText": "Dette er en bekreftelse på time bestilt hos {0}. Velkommen til oss {1} kl. {2}!",
  "EmailProductReservationSubject": "",
  "EmailProductReservationText": "Dette er en bekreftelse på produkt bestilt hos {0}. Bestillingen kan hentes fra og med {1} kl. {2}!",
  "Enabled": true,
  "EndHourExceptions": "1970-01-01T00:00:00",
  "EndHours": "1970-01-01T00:00:00",
  "ExtraTextTreatments": "Det finnes et utvalg behandlinger som vi ikke tilbyr på Online bestilling. Ring oss for nærmere informasjon.",
  "FaceBookUrl": "https://www.facebook.com/ramsvik",
  "FacebookUrlEnabled": true,
  "HasAvailableCampaigns": true,
  "HideEmployees": false,
  "HomePageUrl": "http://ramsvik.test.odindata.no",
  "ImageLocation": "https://res.cloudinary.com/odin-systemer-test/image/upload/w_370,h_196,c_fill,g_center/v1552293469/Department/department_101_webbanner.jpg",
  "ImgAltDesciption": "",
  "Industry": 0,
  "InstagramUrl": "https://www.instagram.com/ramsvik",
  "InstagramUrlEnabled": true,
  "InvoiceAddress": "",
  "InvoicePostalArea": "",
  "InvoicePostalCode": "",
  "IphoneActive": true,
  "IphoneActiveAndEnabled": true,
  "IphoneEnabled": true,
  "IsOpen": false,
  "IsOpenException": false,
  "JournalCustomFieldAnamnese": "",
  "JournalCustomFieldDiagnosis": "",
  "JournalCustomFieldTreatment": "",
  "MapLatitude": "69.169341",
  "MapLongitude": "23.508728",
  "MapReferenceUseContactInfo": 1,
  "MapUrl": "",
  "MetaDescription": "fixitonlineweb Fixitno_Department fedda tester",
  "MetaKeywords": "",
  "MobileThemeName": "",
  "MobileThemeVersion": 0,
  "Name": "Ramsvik Bergen Sentrum",
  "NoOfRatings": 0,
  "OdinTreatmentIds": null,
  "Open": true,
  "OpenNoConnection": false,
  "OrderDayBeforeReminder": false,
  "OrderSameDayReminder": false,
  "OrganizationNumber": "",
  "PageUrlForSharing": 1,
  "Phone": "55310488",
  "PickUpText": null,
  "PostalArea": "BERGEN",
  "PostalCode": "5014",
  "PreviewTreatments": null,
  "ProductReservationGraceDays": 5,
  "ProductReservationPickUpMinutes": 30,
  "ProductReservationPickUpText": "",
  "RatingCommentsFixitnoCount": 0,
  "SendEmailConfirmation": true,
  "SendEmailConfirmationToSite": true,
  "SendSmsConfirmation": true,
  "ShowInFixItNo": false,
  "ShowPrice": true,
  "Site": "BR01",
  "SiteId": 101,
  "SmsConfirmationText": "Dette er en bekreftelse på time bestilt hos {0}. Velkommen til oss {1} kl. {2}!",
  "SmsProductReservationText": "",
  "SmsSenderNumber": "ramsvik",
  "SnapchatUrl": "https://www.snapchat.com/add/ramsvik",
  "SnapchatUrlEnabled": true,
  "SortOnPopularity": false,
  "StartHourExceptions": "1970-01-01T00:00:00",
  "StartHoures": "1970-01-01T00:00:00",
  "Status": true,
  "TimeSuggestionSize": 15,
  "UrlFrendlyLink": "ramsvik-bergen-sentrum",
  "UrlLink": null,
  "UseChainLogo": false
},
{
  "openingHours": [
      {
        "from": "08:00",
        "to": "16:00",
        "day": 1,
        "siteId": 101,
        "isOpen": true
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 2,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 3,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 4,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 5,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 6,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 7,
        "siteId": 101,
        "isOpen": false
      }
  ],
  "Active": true,
  "Address": "OLAV KYRRESGT. 33",
  "AndroidActive": true,
  "AndroidActiveAndEnabled": true,
  "AndroidEnabled": true,
  "AppointmentButtonOverrideText": null,
  "AppointmentButtonOverrideUrl": null,
  "AvailableCategories": null,
  "AvailableTreatments": null,
  "AverageRating": 0,
  "BankAccountNumber": "",
  "BonusLifeTime": 24,
  "BookingHours": 0,
  "CancelationHours": 16,
  "CancelationText": "Du kan direkte fra denne applikasjonen avbestille din time inntil 12 timer før avtale. Ved avbestilling mindre enn 12 timer før avtale må du ringe direkte til salongen.",
  "CancelationTitle": "",
  "CancellationTextProduct": "Du kan når som helst avbestille produkter",
  "ChainId": 36,
  "ChainLogoImageVersion": 0,
  "CollectAtStoreEnabled": true,
  "CustomerNote": false,
  "DepartmentProgress": 64,
  "Description": "",
  "DistanceFromLocationInMeters": 0,
  "Email": "demo@vitecsoftware.com",
  "EmailConfirmationSenderAddress": "ikkesvar@odinsystemer.no",
  "EmailConfirmationSubject": "Velkommen til ny time!",
  "EmailConfirmationText": "Dette er en bekreftelse på time bestilt hos {0}. Velkommen til oss {1} kl. {2}!",
  "EmailProductReservationSubject": "",
  "EmailProductReservationText": "Dette er en bekreftelse på produkt bestilt hos {0}. Bestillingen kan hentes fra og med {1} kl. {2}!",
  "Enabled": true,
  "EndHourExceptions": "1970-01-01T00:00:00",
  "EndHours": "1970-01-01T00:00:00",
  "ExtraTextTreatments": "Det finnes et utvalg behandlinger som vi ikke tilbyr på Online bestilling. Ring oss for nærmere informasjon.",
  "FaceBookUrl": "https://www.facebook.com/ramsvik",
  "FacebookUrlEnabled": true,
  "HasAvailableCampaigns": true,
  "HideEmployees": false,
  "HomePageUrl": "http://ramsvik.test.odindata.no",
  "ImageLocation": "https://res.cloudinary.com/odin-systemer-test/image/upload/w_370,h_196,c_fill,g_center/v1552293469/Department/department_101_webbanner.jpg",
  "ImgAltDesciption": "",
  "Industry": 0,
  "InstagramUrl": "https://www.instagram.com/ramsvik",
  "InstagramUrlEnabled": true,
  "InvoiceAddress": "",
  "InvoicePostalArea": "",
  "InvoicePostalCode": "",
  "IphoneActive": true,
  "IphoneActiveAndEnabled": true,
  "IphoneEnabled": true,
  "IsOpen": false,
  "IsOpenException": false,
  "JournalCustomFieldAnamnese": "",
  "JournalCustomFieldDiagnosis": "",
  "JournalCustomFieldTreatment": "",
  "MapLatitude": "59.9153815434444",
  "MapLongitude": "10.743346762640194",
  "MapReferenceUseContactInfo": 1,
  "MapUrl": "",
  "MetaDescription": "fixitonlineweb Fixitno_Department fedda tester",
  "MetaKeywords": "",
  "MobileThemeName": "",
  "MobileThemeVersion": 0,
  "Name": "Ramsvik Bergen Sentrum",
  "NoOfRatings": 0,
  "OdinTreatmentIds": null,
  "Open": true,
  "OpenNoConnection": false,
  "OrderDayBeforeReminder": false,
  "OrderSameDayReminder": false,
  "OrganizationNumber": "",
  "PageUrlForSharing": 1,
  "Phone": "55310488",
  "PickUpText": null,
  "PostalArea": "BERGEN",
  "PostalCode": "5014",
  "PreviewTreatments": null,
  "ProductReservationGraceDays": 5,
  "ProductReservationPickUpMinutes": 30,
  "ProductReservationPickUpText": "",
  "RatingCommentsFixitnoCount": 0,
  "SendEmailConfirmation": true,
  "SendEmailConfirmationToSite": true,
  "SendSmsConfirmation": true,
  "ShowInFixItNo": false,
  "ShowPrice": true,
  "Site": "BR01",
  "SiteId": 101,
  "SmsConfirmationText": "Dette er en bekreftelse på time bestilt hos {0}. Velkommen til oss {1} kl. {2}!",
  "SmsProductReservationText": "",
  "SmsSenderNumber": "ramsvik",
  "SnapchatUrl": "https://www.snapchat.com/add/ramsvik",
  "SnapchatUrlEnabled": true,
  "SortOnPopularity": false,
  "StartHourExceptions": "1970-01-01T00:00:00",
  "StartHoures": "1970-01-01T00:00:00",
  "Status": true,
  "TimeSuggestionSize": 15,
  "UrlFrendlyLink": "ramsvik-bergen-sentrum",
  "UrlLink": null,
  "UseChainLogo": false
},
{
  "openingHours": [
      {
        "from": "08:00",
        "to": "16:00",
        "day": 1,
        "siteId": 101,
        "isOpen": true
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 2,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 3,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 4,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 5,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 6,
        "siteId": 101,
        "isOpen": false
      },
      {
        "from": "08:00",
        "to": "16:00",
        "day": 7,
        "siteId": 101,
        "isOpen": false
      }
  ],
  "Active": true,
  "Address": "OLAV KYRRESGT. 33",
  "AndroidActive": true,
  "AndroidActiveAndEnabled": true,
  "AndroidEnabled": true,
  "AppointmentButtonOverrideText": null,
  "AppointmentButtonOverrideUrl": null,
  "AvailableCategories": null,
  "AvailableTreatments": null,
  "AverageRating": 0,
  "BankAccountNumber": "",
  "BonusLifeTime": 24,
  "BookingHours": 0,
  "CancelationHours": 16,
  "CancelationText": "Du kan direkte fra denne applikasjonen avbestille din time inntil 12 timer før avtale. Ved avbestilling mindre enn 12 timer før avtale må du ringe direkte til salongen.",
  "CancelationTitle": "",
  "CancellationTextProduct": "Du kan når som helst avbestille produkter",
  "ChainId": 36,
  "ChainLogoImageVersion": 0,
  "CollectAtStoreEnabled": true,
  "CustomerNote": false,
  "DepartmentProgress": 64,
  "Description": "",
  "DistanceFromLocationInMeters": 0,
  "Email": "demo@vitecsoftware.com",
  "EmailConfirmationSenderAddress": "ikkesvar@odinsystemer.no",
  "EmailConfirmationSubject": "Velkommen til ny time!",
  "EmailConfirmationText": "Dette er en bekreftelse på time bestilt hos {0}. Velkommen til oss {1} kl. {2}!",
  "EmailProductReservationSubject": "",
  "EmailProductReservationText": "Dette er en bekreftelse på produkt bestilt hos {0}. Bestillingen kan hentes fra og med {1} kl. {2}!",
  "Enabled": true,
  "EndHourExceptions": "1970-01-01T00:00:00",
  "EndHours": "1970-01-01T00:00:00",
  "ExtraTextTreatments": "Det finnes et utvalg behandlinger som vi ikke tilbyr på Online bestilling. Ring oss for nærmere informasjon.",
  "FaceBookUrl": "https://www.facebook.com/ramsvik",
  "FacebookUrlEnabled": true,
  "HasAvailableCampaigns": true,
  "HideEmployees": false,
  "HomePageUrl": "http://ramsvik.test.odindata.no",
  "ImageLocation": "https://res.cloudinary.com/odin-systemer-test/image/upload/w_370,h_196,c_fill,g_center/v1552293469/Department/department_101_webbanner.jpg",
  "ImgAltDesciption": "",
  "Industry": 0,
  "InstagramUrl": "https://www.instagram.com/ramsvik",
  "InstagramUrlEnabled": true,
  "InvoiceAddress": "",
  "InvoicePostalArea": "",
  "InvoicePostalCode": "",
  "IphoneActive": true,
  "IphoneActiveAndEnabled": true,
  "IphoneEnabled": true,
  "IsOpen": false,
  "IsOpenException": false,
  "JournalCustomFieldAnamnese": "",
  "JournalCustomFieldDiagnosis": "",
  "JournalCustomFieldTreatment": "",
  "MapLatitude": "59.92121353260851",
  "MapLongitude": "10.681149719362415",
  "MapReferenceUseContactInfo": 1,
  "MapUrl": "",
  "MetaDescription": "fixitonlineweb Fixitno_Department fedda tester",
  "MetaKeywords": "",
  "MobileThemeName": "",
  "MobileThemeVersion": 0,
  "Name": "Ramsvik Bergen Sentrum",
  "NoOfRatings": 0,
  "OdinTreatmentIds": null,
  "Open": true,
  "OpenNoConnection": false,
  "OrderDayBeforeReminder": false,
  "OrderSameDayReminder": false,
  "OrganizationNumber": "",
  "PageUrlForSharing": 1,
  "Phone": "55310488",
  "PickUpText": null,
  "PostalArea": "BERGEN",
  "PostalCode": "5014",
  "PreviewTreatments": null,
  "ProductReservationGraceDays": 5,
  "ProductReservationPickUpMinutes": 30,
  "ProductReservationPickUpText": "",
  "RatingCommentsFixitnoCount": 0,
  "SendEmailConfirmation": true,
  "SendEmailConfirmationToSite": true,
  "SendSmsConfirmation": true,
  "ShowInFixItNo": false,
  "ShowPrice": true,
  "Site": "BR01",
  "SiteId": 101,
  "SmsConfirmationText": "Dette er en bekreftelse på time bestilt hos {0}. Velkommen til oss {1} kl. {2}!",
  "SmsProductReservationText": "",
  "SmsSenderNumber": "ramsvik",
  "SnapchatUrl": "https://www.snapchat.com/add/ramsvik",
  "SnapchatUrlEnabled": true,
  "SortOnPopularity": false,
  "StartHourExceptions": "1970-01-01T00:00:00",
  "StartHoures": "1970-01-01T00:00:00",
  "Status": true,
  "TimeSuggestionSize": 15,
  "UrlFrendlyLink": "ramsvik-bergen-sentrum",
  "UrlLink": null,
  "UseChainLogo": false
},

] 

export default {
  dummySalons: DummySalons
}